import api from "./api";
import config from "../config";
import { stringify } from "qs";

export default {
  get(person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}/wishlist`,
          qs: { token: person }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  update(person, wishlist, _diff) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets/${config.event_bucket}/wishlist`,
          json: {
            token: person,
            wishlist: wishlist,
            _diff: _diff
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.wishlist);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/WishlistUtil.js